import { v1 as uuidv1, v4 as uuidv4 } from 'uuid';

function _generateUniqueId({
  length = 12,
  useV1 = false,
  addExtraRandomness = true
} = {}) {
  const random = Math.random;
  const min = Math.min;
  const max = Math.max;

  const fullUuid = useV1 ? uuidv1() : uuidv4();

  let result = fullUuid.replace(/-/g, '');

  if (length > 32) {
    const extra = uuidv4().replace(/-/g, '');
    result += extra;
  }

  result = result.substring(0, min(length, result.length));

  if (addExtraRandomness) {
    const chars = result.split('');
    const alphabets = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const positionsToReplace = new Set();

    const replaceCount = Math.max(1, Math.floor(length * 0.2));

    while (positionsToReplace.size < replaceCount) {
      positionsToReplace.add(Math.floor(random() * chars.length));
    }

    for (const pos of positionsToReplace) {
      chars[pos] = alphabets.charAt(Math.floor(random() * alphabets.length));
    }

    result = chars.join('');
  }

  return result;
}

export function useIdGenerator() {
  const generateIncidentId = (length = 8) => {
    return _generateUniqueId({ length, useV1: true });
  };

  const generateChatId = () => {
    return _generateUniqueId({ length: 24, addExtraRandomness: true });
  };

  const generateOrganizationId = () => {
    // Format: yyyymmdd + random 4-digit number => e.g., 202507220123
    const now = new Date();
    const datePart = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}${now
      .getDate()
      .toString()
      .padStart(2, '0')}`;
    const randomPart = Math.floor(1000 + Math.random() * 9000); // 4-digit random number

    return parseInt(`${datePart}${randomPart}`);
  };

  const generateSiteId = () => {
    // Format: yyyymmdd + random 6-digit number => e.g., 20250722012345
    const now = new Date();
    const datePart = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}${now
      .getDate()
      .toString()
      .padStart(2, '0')}`;
    const randomPart = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
    return parseInt(`${datePart}${randomPart}`);
  };

  return { generateIncidentId, generateChatId, generateOrganizationId, generateSiteId };
}